import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  style: {"margin-bottom":"10px"},
  class: "grid ml-0 mr-1"
}
const _hoisted_3 = {
  class: "col",
  style: {"min-width":"200px"}
}
const _hoisted_4 = { class: "flex flex-auto p-input-icon-left p-input-icon-right" }
const _hoisted_5 = { class: "col-fixed" }
const _hoisted_6 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_7 = { style: {"padding":"10px","width":"100%","padding-top":"0px"} }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "grid flex-nowrap" }
const _hoisted_10 = {
  key: 0,
  class: "col-fixed hidden xl:block tablecol-active"
}
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "grid flex-nowrap hover-row" }
const _hoisted_13 = { class: "col-fixed tablecol-icon" }
const _hoisted_14 = {
  key: 0,
  class: "pi pi-fw pi-file-pdf"
}
const _hoisted_15 = {
  key: 1,
  class: "pi pi-fw pi-file-excel"
}
const _hoisted_16 = {
  key: 2,
  class: "pi pi-fw pi-file"
}
const _hoisted_17 = { class: "col tablecol-name" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "col-fixed hidden md:block tablecol-uploaded" }
const _hoisted_20 = { class: "col-fixed hidden xl:block tablecol-size" }
const _hoisted_21 = {
  key: 0,
  class: "col-fixed hidden xl:block tablecol-active"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "pi pi-circle-fill"
}
const _hoisted_24 = {
  key: 1,
  class: "pi pi-circle"
}
const _hoisted_25 = {
  key: 1,
  class: "col-fixed text-right"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_DocumentGeneration = _resolveComponent("DocumentGeneration")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Documents", -1)),
      _createVNode(_component_TabView, {
        activeIndex: _ctx.activeDocumentPanelTab,
        "onUpdate:activeIndex": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeDocumentPanelTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "pi pi-file" }, null, -1),
              _createTextVNode("  ", -1),
              _createElementVNode("span", null, "Docs", -1)
            ]))]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.filterText,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterText) = $event)),
                      placeholder: "Document keyword filter.."
                    }, null, 8, ["modelValue"]),
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "Since: ", -1)),
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                      showIcon: true,
                      dateFormat: "d M yy",
                      placeholder: "Date from",
                      showButtonBar: true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (_ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_InputSwitch, {
                        modelValue: _ctx.onlyActive,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.onlyActive) = $event)),
                        class: "ml-4 mr-1"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("a", {
                        class: "mr-4",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onlyActive=!_ctx.onlyActive))
                      }, "Only active")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_DataView, {
                  value: _ctx.filteredDocumentsList,
                  datakey: "propertyServiceId",
                  paginator: true,
                  rows: 10,
                  scrollable: true,
                  stripedRows: "",
                  class: "p-datatable-sm",
                  paginatorTemplate: _ctx.paginatorTemplate,
                  rowsPerPageOptions: [10,20,50,100,200],
                  responsiveLayout: "scroll",
                  alwaysShowPaginator: false,
                  currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-fixed tablecol-icon" }, null, -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col tablecol-name" }, "Name", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-fixed hidden md:block tablecol-uploaded" }, "Uploaded", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-fixed hidden xl:block tablecol-size" }, "Size (KB)", -1)),
                        (_ctx.canEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Active"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  list: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          (data.fileName.toUpperCase().includes('.PDF'))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                            : (data.fileName.toUpperCase().includes('.XLS'))
                              ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                              : (_openBlock(), _createElementBlock("i", _hoisted_16))
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.downloadDocument(data.documentId))
                          }, _toDisplayString(data.fileName), 9, _hoisted_18)
                        ]),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formattedDate(data.whenUploaded)), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(data.size), 1),
                        (_ctx.canEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _withDirectives((_openBlock(), _createElementBlock("a", {
                                onClick: ($event: any) => (data.active =!data.active)
                              }, [
                                (data.active)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_24))
                              ], 8, _hoisted_22)), [
                                [
                                  _directive_tooltip,
                                  'Toggle active',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.canEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _withDirectives((_openBlock(), _createElementBlock("a", {
                                onClick: ($event: any) => {data.whenDeleted = new Date();}
                              }, [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "pi pi-times" }, null, -1)
                              ]))], 8, _hoisted_26)), [
                                [
                                  _directive_tooltip,
                                  'Delete document',
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "paginatorTemplate"])
              ])
            ]),
            _: 1
          }),
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                header: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "pi pi-upload" }, null, -1),
                  _createTextVNode("  ", -1),
                  _createElementVNode("span", null, "Upload", -1)
                ]))]),
                default: _withCtx(() => [
                  (!_ctx.uploading)
                    ? (_openBlock(), _createBlock(_component_FileUpload, {
                        key: 0,
                        name: "files[]",
                        customUpload: true,
                        onUploader: _ctx.fileUpload,
                        multiple: true,
                        auto: false,
                        accept: ".pdf,.doc,.docx,.xls,.xlsx",
                        onSelect: _ctx.fileSelected
                      }, {
                        empty: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("p", null, "Drag and drop files here to upload.", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onUploader", "onSelect"]))
                    : _createCommentVNode("", true),
                  (_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("span", { style: {"font-size":"2rem"} }, [
                          _createElementVNode("i", {
                            class: "pi pi-spin pi-spinner",
                            style: {"font-size":"2rem"}
                          }),
                          _createTextVNode(" Uploading...")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                header: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "pi pi-compass" }, null, -1),
                  _createTextVNode("  ", -1),
                  _createElementVNode("span", null, "Generate", -1)
                ]))]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypes.main, (doc) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-6 lg:col-3",
                      key: doc.label
                    }, [
                      _createVNode(_component_Button, {
                        style: {"width":"100%","border-radius":"20px"},
                        onClick: ($event: any) => (_ctx.toggleDocumentGenerationDialog(doc.templateName))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(doc.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    (_ctx.showDocumentGenerationComponent)
      ? (_openBlock(), _createBlock(_component_DocumentGeneration, {
          key: 0,
          selectedDocumentTemplate: _ctx.selectedDocumentTemplate,
          propertyData: _ctx.propertyData,
          initialActiveTab: 0,
          onUpdateActiveDocumentPanelTab: _cache[5] || (_cache[5] = ($event: any) => {_ctx.activeDocumentPanelTab = $event;}),
          onUpdateShowDocumentGenerationComponent: _cache[6] || (_cache[6] = ($event: any) => {_ctx.showDocumentGenerationComponent = $event;})
        }, null, 8, ["selectedDocumentTemplate", "propertyData"]))
      : _createCommentVNode("", true)
  ], 64))
}